import Section from 'Components/ContractGenerator/layouts/Section';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';
import { Headline } from 'ViatoUi/Shared/Typo';
import Translation from 'ViatoUi/Shared/Utilities/Translation';
import Button from 'ViatoUi/Web/FormElements/Buttons/Button';

const Step5 = () => {
	const { t } = useTranslation('contractGenerator');

	const sharedConstants = useSelector(contractGeneratorSelectors.getConstants);
	const contractId = useSelector(contractGeneratorSelectors.getContractId);

	return (
		<Section firstElementOfStep>
			<div>
				<Headline type='h1'>{t('pages.step5.h1')}</Headline>
				<Spacer height='l' />
				<strong>{t('pages.step5.h2')}</strong>
				<br />
				{t('pages.step5.paragraph1')}
				<br />
				<br />
				<Translation
					components={[
						{
							type: 'variable',
							props: { value: contractId }
						},
						{
							type: 'anchor',
							props: { href: `tel:${sharedConstants.COMPANY.PHONE.replaceAll(' ', '')}` }
						},
						{
							type: 'anchor',
							props: { href: `mailto:${sharedConstants.COMPANY.CONTACT_MAIL}` }
						},
						{
							type: 'variable',
							props: { value: sharedConstants.COMPANY.CONTACT_MAIL }
						},
						{
							type: 'variable',
							props: { value: sharedConstants.COMPANY.PHONE }
						}
					]}
					translationKey='pages.step5.paragraph2'
					translationNamespace='contractGenerator'
				/>
				<br />
				<br />
				{t('pages.step5.paragraph3')}
				<br />
				<br />
				{t('pages.step5.paragraph4')}
				<br />
				<br />
				{t('pages.step5.paragraph5')}
				<Spacer height='xl' />
				<Button
					type='secondary'
					onClick={() => {
						window.location.reload();
					}}
				>
					{t('app.userActions.backToStart')}
				</Button>
			</div>
		</Section>
	);
};

export default Step5;
